import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getPaymentMethods } from '../../../actions/member-payment-actions';
import { gtag } from '../../Analytics/gtag';
import CheckoutForm from '../../CheckoutForm';
import Img from '../../Img';
import Popup from '../../Popup/PopupV2';
import * as popupActions from '../../../actions/popup-actions';
import { PopupTypes } from '../../../utils/constants';

import styles from './upgradeV2.scss';
import popupStyles from '../../Popup/popupv2.scss';

const UpgradeToPowerPopupV2 = (props) => {
    const [interval, setInterval] = useState('year');
    const [playerPaymentMethods, setPlayerPaymentMethods] = useState([]);
    const popups = useSelector(({ popups }) => popups);
    const dispatch = useDispatch();

    const getSavedPaymentMethods = async () => {
        const savedPaymentMethod = await dispatch(getPaymentMethods());
        setPlayerPaymentMethods(savedPaymentMethod);
    };

    useEffect(() => {
        getSavedPaymentMethods();
    }, []);

    const handleSuccess = () => {
        gtag('power-upgrade', {
            category: 'Power Upgrade',
            context: `Upgrade success`,
        });
        dispatch(popupActions.closePopup(PopupTypes.POWER_UPGRADE_POPUP));
        dispatch(popupActions.showPopupNew({
            popup: PopupTypes.POWER_SUCCESS_POPUP_V2,
            redirectTo: popups.redirectTo,
        }));
    };

    const handlePlanClick = (interval) => {
        setInterval(interval);
    };

    const modalHeader = () => {
        return (
            <div className={`asdf ${popupStyles.modalHeader} ${styles.header}`}>
                <div className={styles.background}>
                    <Img src="/img/v3/graphics/modals/power-up-your-play-2x.png" />
                </div>
                <div
                    className={`${popupStyles.btnClose} ${styles.close}`}
                    onClick={props.onCloseClick}
                    data-testid="modal.power-upgrade.close-btn"
                >
                    <i className={`utr utr-close`} />
                </div>
            </div>
        );
    };

    return (
        <div className={styles.popup}>
            <Popup
                className="popup-md"
                config={{
                    size: 'md',
                    scrollable: true,
                    customHeader: modalHeader,
                    customWidth: '630px',
                }}
                onCloseClick={props.onCloseClick}
            >
                <div className={styles.content}>
                    <div className={styles.title}>
                        Why subscribe?
                    </div>
                    <div className={styles.subtitle}>
                        A Power subscription enhances your experience both on and off the court! Gain access to exclusive views, perks, deals and more!
                    </div>
                    <div className={styles.perks}>
                        <div className="row">
                            <div className="col-12 col-md-6 mb16">
                                <div className={styles.perk}>
                                    <div className={styles.icon}>
                                        <Img src="/img/v3/icons/two-decimals.svg" />
                                    </div>
                                    <div className={styles.title}>
                                        Full Two-Decimal Rating Display
                                    </div>
                                    <div className={styles.description}>
                                        Unlock two-decimal ratings for everyone on the platform
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-6 mb16">
                                <div className={styles.perk}>
                                    <div className={styles.icon}>
                                        <Img src="/img/v3/icons/loyalty.svg" />
                                    </div>
                                    <div className={styles.title}>
                                        Discounted Entry Fees
                                    </div>
                                    <div className={styles.description}>
                                        $0 Verified Fees for all events
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-6 mb16">
                                <div className={styles.perk}>
                                    <div className={styles.icon}>
                                        <Img src="/img/v3/icons/analytics.svg" />
                                    </div>
                                    <div className={styles.title}>
                                        Advanced Analytics
                                    </div>
                                    <div className={styles.description}>
                                        Unleash your performance potential through strategic insights
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-6 mb16">
                                <div className={styles.perk}>
                                    <div className={styles.icon}>
                                        <Img src="/img/v3/icons/redeem.svg" />
                                    </div>
                                    <div className={styles.title}>
                                        Exclusive Perks
                                    </div>
                                    <div className={styles.description}>
                                        Enjoy discounts on gear and apparel from your favorite brands
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.sectionTitle}>
                        Choose your plan:
                    </div>
                    <div className={styles.plan}>
                        <div className="row">
                            <div className="col-12 col-md-6">
                                <div
                                    className={`${styles.button} ${interval === 'year' ? styles.selected : ''}`}
                                    onClick={() => handlePlanClick('year')}
                                    data-testid="modal.power-upgrade.annual-plan-option"
                                >
                                    <div className={`${styles.checkbox} d-flex d-md-none`}>
                                        <Img src="/img/icons/checkmark-icon.svg" />
                                    </div>
                                    <div className={`${styles.label} d-block d-md-none`} data-testid="modal.power-upgrade.annual-plan-name">
                                        Annual Plan
                                    </div>
                                    <div className={`d-none d-md-flex jcsb aic w-100`}>
                                        <div className={`${styles.label}`}>
                                            Annual Plan
                                        </div>
                                        <div className={`${styles.checkbox}`}>
                                            <Img src="/img/icons/checkmark-icon.svg" />
                                        </div>
                                    </div>
                                    <div className={`${styles.info}`}>
                                        <div className={`${styles.price}`}>
                                            <div className={styles.monthly}>
                                                $10.00<span className="fs12 text-normal">/month</span>
                                            </div>
                                            <div className={`${styles.yearly}`} data-testid="modal.power-upgrade.annual-plan-fee">
                                                $120/year
                                            </div>
                                        </div>
                                        <div className={`${styles.label}`}>
                                            Save 16%
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-6">
                                <div
                                    className={`${styles.button} ${interval === 'month' ? styles.selected : ''}`}
                                    onClick={() => handlePlanClick('month')}
                                    data-testid="modal.power-upgrade.monthly-plan-option"
                                >
                                    <div className={`${styles.checkbox} d-flex d-md-none`}>
                                        <Img src="/img/icons/checkmark-icon.svg" />
                                    </div>
                                    <div className={`${styles.label} d-block d-md-none`} data-testid="modal.power-upgrade.monthly-plan-name">
                                        Monthly Plan
                                    </div>
                                    <div className={`d-none d-md-flex jcsb aic w-100`}>
                                        <div className={`${styles.label}`}>
                                            Monthly Plan
                                        </div>
                                        <div className={`${styles.checkbox}`}>
                                            <Img src="/img/icons/checkmark-icon.svg" />
                                        </div>
                                    </div>
                                    <div className={`${styles.info}`}>
                                        <div className={`${styles.price}`} data-testid="modal.power-upgrade.monthly-plan-fee">
                                            $12.00<span className="fs12 text-normal">/month</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mt40 mb24">
                        <div className={styles.sectionTitle} data-testid="modal.power-upgrade.plan-title">
                            Choose your plan:
                        </div>
                        <div className={styles.cards}>
                            <div className={styles.cardsTitle} data-testid="modal.power-upgrade.cards-text">
                                We accept all major credit cards.
                            </div>
                            <Img src="/img/v3/graphics/cards/visa.png" />
                            <Img src="/img/v3/graphics/cards/mastercard.png" />
                            <Img src="/img/v3/graphics/cards/amex.png" />
                            <Img src="/img/v3/graphics/cards/discover.png" />
                        </div>
                        <CheckoutForm
                            formType="powered"
                            interval={interval}
                            onUpdate={() => {}}
                            onComplete={handleSuccess}
                            couponCode={null}
                            playerPaymentMethods={playerPaymentMethods}
                            hideHeader
                            themeV3
                            hideSaveCard
                        />
                    </div>
                    <div className={`${styles.disclaimer}`}>
                        By tapping the button, I agree to the terms and automatic charges until I cancel.
                    </div>
                </div>
            </Popup>
        </div>
    );
};

export default UpgradeToPowerPopupV2;
